import './jquery'
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import i18n from './i18n'
import Logger from './assets/scripts/logger.js'
import '@/assets/scripts/videoPlayer.js'
import '@/assets/css/skin.css'
import '@/assets/css/videoPlayer.css'

Vue.config.productionTip = false

Vue.use(VueCookie);
Vue.use(Logger);

String.prototype.format = function()
{
   var content = this;
   for (var i=0; i < arguments.length; i++)
   {
        var replacement = '{' + i + '}';
        content = content.replace(replacement, arguments[i]); 
   }
   return content;
};

new Vue({
	vuetify,
	i18n,
	data: {
		browser: {
			name: "unknown",
			version: "unknown"
		},
		device: {
			windows: null,
			windowsPhone: null,
			ipod: null,
			ipad: null,
			iphone: null,
			ios: null,
			mac: null,
			android: null,
			androidPhone: null,
			mobile: null
		},
	},
	beforeCreate() {
		Logger.log("main.js beforeCreate");
	},
	created() {
		Logger.log("main.js created");

		// set browser information
		this.setBrowserInfo();

		// set device properties
		this.setDeviceProperties();
		
		// set the current language
		this.setCurLanguage();

		// set window title
		document.title = this.$t("windowTitle");
	},
	beforeMount() {
		Logger.log("main.js beforeMount");
	},
	mounted() {
		Logger.log("main.js mounted");
	},
	beforeUpdate() {
		Logger.log("main.js beforeUpdate");
	},
	updated() {
		Logger.log("main.js updated");
	},
	beforeDestroy() {
		Logger.log("main.js beforeDestroy");
	},
	destroyed() {
		Logger.log("main.js destroyed");
	},
	methods: {
		setCurLanguage() {
			// set language according to browser
			// default language is set in i18n.js
			var curLocale = navigator.language || navigator.browserLanguage,
				supportedLanguages = this.$i18n.availableLocales;
			if (curLocale && supportedLanguages) {
				curLocale = curLocale.toLowerCase();
				for (var i= 0; i < supportedLanguages.length; i++) {
					if (curLocale.indexOf(supportedLanguages[i]) == 0) {
						this.$i18n.locale = supportedLanguages[i];
						break;
					}
				}
			}
		},
		setBrowserInfo() {
			// set the browser information
			if (window.navigator && window.navigator.userAgent) {
				var input, result, userAgent = window.navigator.userAgent.toLowerCase();
				/**** Edge ****/
				if (userAgent.indexOf("edge/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("edge/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "edge";
						this.browser.version = splits[1];
					}
				}
				/**** Opera ****/
				else if (userAgent.indexOf("opr/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("opr/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "opera";
						this.browser.version = splits[1];
					}
				}
				else if (userAgent.indexOf("opera/") !== -1 && userAgent.indexOf("version/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("version/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "opera";
						this.browser.version = splits[1];
					}
				}
				else if (userAgent.indexOf("opera ") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("opera ")),
						splits = substring.split(" ");
					if (splits && splits.length > 1) {
						this.browser.name = "opera";
						this.browser.version = splits[1];
					}
				}
				else if (userAgent.indexOf("opera/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("opera/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "opera";
						this.browser.version = splits[1];
					}
				}
				/**** Chrome ****/
				else if (userAgent.indexOf("chrome/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("chrome/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "chrome";
						this.browser.version = splits[1];
					}
				}
				/**** Safari ****/
				else if (userAgent.indexOf("safari/") !== -1 && userAgent.indexOf("version/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("version/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "safari";
						this.browser.version = splits[1];
					}
				}
				/**** Firefox ****/
				else if (userAgent.indexOf("firefox/") !== -1) {
					var substring = userAgent.substring(userAgent.indexOf("firefox/")).split(" ")[0],
						splits = substring.split("/");
					if (splits && splits.length > 1) {
						this.browser.name = "firefox";
						this.browser.version = splits[1];
					}
				}
				/**** Internet Explorer ****/
				else if (result = userAgent.match(/\(([^()]+)\)/)) { // first substring within parentheses
					input = result[0];
					if (input.indexOf("trident/") !== -1 && input.indexOf("rv:11") !== -1) { // IE 11
						this.browser.name = "msie";
						this.browser.version = "11";
					}
					else if (input.indexOf("msie ") !== -1) { // IE 10 and older
						var substring = input.substring(input.indexOf("msie ")).split(";")[0],
							splits = substring.split(" ");
						if (splits && splits.length > 1) {
							this.browser.name = "msie";
							this.browser.version = splits[1];
						}
					}
				}
			}
		},
		setDeviceProperties() {
			// set device properties
			if (window.navigator && window.navigator.userAgent) {
				var userAgent = window.navigator.userAgent.toLowerCase();
				this.device.windows = userAgent.indexOf("windows") !== -1;
				this.device.windowsPhone = this.device.windows && userAgent.indexOf("mobile") !== -1;
				this.device.ipod = userAgent.indexOf("ipod") !== -1;
				this.device.ipad = userAgent.indexOf("ipad") !== -1 && userAgent.indexOf("webkit") !== -1;
				this.device.iphone = !this.device.windows && userAgent.indexOf("iphone") !== -1 && !this.device.ipad && !this.device.ipod;
				this.device.ios = this.device.iphone || this.device.ipad || this.device.ipod;
				this.device.mac = userAgent.indexOf("macintosh") !== -1;
				this.device.android = userAgent.indexOf("android") !== -1;
				this.device.androidPhone = this.device.android && userAgent.indexOf("mobile") !== -1;
				this.device.mobile = this.device.androidPhone || this.device.iphone || this.device.ipod || this.device.windowsPhone;
			}
		}
	},
	render: h => h(App)
}).$mount('#app')
